
import { defineComponent, ref, onMounted } from 'vue';

import store from '@/store';

// @ts-ignore
import taskLists from 'markdown-it-task-lists';

export default defineComponent({
	props: {
		parent_id: {
			type: String,
			required: true,
		},
	},
	setup(props, { emit }) {
		const mdPreview = ref(false);
		const commentInput = ref('');
		onMounted(() => window.scrollBy(0, 250));

		async function createComment() {
			if (!commentInput.value.replace(/\s+/g, '').length) return alert('Your comment must not be empty.');

			await store.post.actions.createComment({
				content: commentInput.value,
				post_id: store.post.state.currentPost.id || '',
				parent_id: props.parent_id,
				subreddit_id: store.post.state.currentPost.subreddit_id || '',
				user_id: store.auth.state.user?.id || '',
			});
			commentInput.value = '';
			emit('hideCreateComment');
		}

		return {
			store,
			mdPreview,
			commentInput,
			createComment,
			taskLists,
		};
	},
});
